import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsuranceIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.0723 0.80127C12.0724 1.9647 13.236 3.1281 14.3994 3.12842V8.36475C14.3994 11.0798 12.2665 13.4068 8 15.3462C3.73337 13.4068 1.59961 11.0799 1.59961 8.36475V3.12842C2.7632 3.12842 3.92666 1.96486 3.92676 0.80127H12.0723ZM5.07324 2.53857C4.68143 3.26666 4.06407 3.88318 3.33594 4.2749L3.2002 4.34521V8.36475C3.2002 10.1717 4.65243 11.8959 7.83105 13.4937L8 13.5767L8.16895 13.4937C11.259 11.9403 12.7182 10.2673 12.7969 8.51514L12.7998 8.36475V4.34521L12.6631 4.2749C11.935 3.88313 11.3175 3.26667 10.9258 2.53857L10.8555 2.40186H5.14258L5.07324 2.53857ZM10.999 6.13135L7.6543 9.90283L5.0957 7.8208L6.10547 6.57959L7.47461 7.69385L9.80273 5.06982L10.999 6.13135Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgInsuranceIcon);
export { ForwardRef as ReactComponent };
